import { Box, Stack, Typography } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
import JobCategoriesITDevelopmentIcon from "../../../UI/JobCategoriesITDevelopmentIcon";
import SecondSectionAppHome from "../../AppHome/SecondSectionAppHome";
import JobCategoriesFinanceIcon from "../../../UI/JobCategoriesFinanceIcon";
import JobCategoriesHealthCareIcon from "../../../UI/JobCategoriesHealthCareIcon";
import JobCategoriesSalesAndMarketingIcon from "../../../UI/JobCategoriesSalesAndMarketingIcon";
import JobCategoriesEducationIcon from "../../../UI/JobCategoriesEducationIcon";
import JobCategoriesDesignIcon from "../../../UI/JobCategoriesDesignIcon";
import JobCategoriesResearchIcon from "../../../UI/JobCategoriesResearchIcon";
import JobCategoriesHumanResourcesIcon from "../../../UI/JobCategoriesHumanResourcesIcon";
import { useState } from "react";
const cardsData = [
  {
    icon: JobCategoriesITDevelopmentIcon,
    primaryText: "IT Development",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesFinanceIcon,
    primaryText: "Finance",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesHealthCareIcon,
    primaryText: "Healthcare",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesSalesAndMarketingIcon,
    primaryText: "Sales & Marketing",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesEducationIcon,
    primaryText: "Education",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesDesignIcon,
    primaryText: "Design",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesResearchIcon,
    primaryText: "Research",
    SecondaryText: "3,450 open jobs",
  },
  {
    icon: JobCategoriesHumanResourcesIcon,
    primaryText: "Human Resources",
    SecondaryText: "3,450 open jobs",
  },
];
function ExploreOurJobSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { darkMode } = useDarkMode();
  return (
    <Stack id="Explore-our-job-categories" sx={{ px: "98px", py: "70px" }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "700",
          fontSize: "54px",
          lineHeight: "64px",
          fontFamily: "Inter",
          color: darkMode ? "#ffffff" : "#0E0B33",
          maxWidth: 467,
          mb: "4px",
        }}
      >
        Explore our Job Categories
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "26px",
          fontFamily: "Inter",
          color: darkMode ? "#8d8d8d" : "#878599",
          pt: "4px",
        }}
      >
        Get started by looking at our job categories. Hundreds of new jobs
        everyday!
      </Typography>
      <Stack
        direction="row"
        id="job-categories-cards"
        sx={{ flexWrap: "wrap", gap: "20px", py: "50px" }}
      >
        {cardsData.map((card, i) => {
          const activeJob = i === activeIndex;
          return (
            <Stack
              component="button"
              direction="column"
              sx={{
                border: darkMode
                  ? "1px solid #3E3E3E"
                  : `1px solid ${activeJob ? "#E3E3E3" : "#CDCDCD"}`,
                // minWidth: "289.5px",
                minWidth: "323.5px",
                p: "16px",
                borderRadius: "25px",
                bgcolor: "transparent",
                alignItems: "start",
                cursor: "pointer",
                bgcolor: activeJob ? "#F8F8F8" : "transparent",
              }}
              onClick={() => setActiveIndex(i)}
            >
              <Box
                sx={{
                  bgcolor: darkMode
                    ? "#262626"
                    : activeJob
                    ? "#000000"
                    : "#F4F4F4",
                  alignSelf: "start",
                  borderRadius: "20px",
                  // p: "4px",
                  width: "84px",
                  height: "84px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  mb: "50px",
                }}
              >
                {
                  <card.icon
                    color={
                      darkMode
                        ? activeJob
                          ? "#FFDD00"
                          : "#ffffff"
                        : activeJob
                        ? "#ffffff"
                        : "#191515"
                    }
                  />
                }
              </Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  fontSize: "28px",
                  lineHeight: "32px",
                  fontFamily: "Inter",
                  color: darkMode ? "#ffffff" : "#302828",
                }}
              >
                {card.primaryText}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  lineHeight: "26px",
                  fontFamily: "Inter",
                  color: darkMode ? "#8d8d8d" : "#878599",
                }}
              >
                {card.SecondaryText}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}

export default ExploreOurJobSection;
